export const ListItem = ({
  title,
  trailingTitle,
  description,
  actions,
  onClick,
}: {
  title: string | React.ReactNode;
  trailingTitle?: string | React.ReactNode;
  description?: string | React.ReactNode;
  actions?: React.ReactNode;
  onClick?: () => void;
}) => {
  return (
    <div
      className="ease-out-quad flex cursor-pointer items-center justify-between rounded-lg border bg-gray-100 px-5 py-4 hover:bg-gray-200/70"
      onClick={onClick}>
      <div className="min-w-0 flex-1">
        <h3 className="font-medium text-gray-900">
          {title}
          {trailingTitle && (
            <span className="ml-1.5 text-xs text-gray-400">
              {trailingTitle}
            </span>
          )}
        </h3>
        {description && (
          <div className="mt-1 text-sm text-gray-500">{description}</div>
        )}
      </div>
      {actions && <div className="flex shrink-0 gap-2">{actions}</div>}
    </div>
  );
};
